/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动ID
   */
  event_id: string;
  /**
   * 封面图样式
   */
  image_type?: string;
}
export type Labels = string[];
export type VenueType = number[];
export interface DashboardEventBriefInfoRes {
  nonce?: string;
  data: Data;
  code?: number;
  msg?: string;
}
export interface Data {
  event_info?: EventInfo;
  published_event_info: PublishedEventInfo;
}
export interface EventInfo {
  labels?: Labels;
  title?: string;
  start_time?: number;
  end_time?: number;
  event_type?: number;
  address?: string;
  is_public?: number;
  cover_url?: string;
  cover_cos_id?: string;
  /**
   * 收费类型（免费传1，付费传2，免费+付费传3）
   */
  charge_type?: number;
  event_id?: string;
  host_id?: number;
  host_name?: string;
  template?: string;
  time_zone?: string;
  status?: number;
  industry_code?: string;
  industry_name?: string;
  /**
   * 是否超过流水限额
   */
  is_over_limit?: boolean;
  /**
   * 流水限额(单位分)
   */
  money_limit?: string;
  /**
   * 二次编辑状态，0 没有发生二次编辑，1 当前有二次编辑的内容
   */
  reedit_status?: number;
  /**
   * 监管状态 0-正常状态 1-被监管屏蔽
   */
  regulatory_status?: number;
  /**
   * 报错中心分类。1:审核不通过 2:发布失败
   */
  items_sort?: number;
  /**
   * 是否人工审核，0为机器审核，1为人工审核
   */
  is_person_audit?: number;
  /**
   * 审核状态：-1 审核不通过；0 待审核；1 审核通过
   */
  audit_status?: number;
  /**
   * 广场上架状态 0 未上架 1 已上架
   */
  plaza_status?: number;
  venue_type?: VenueType;
  /**
   * 是否首次发布
   */
  is_first_publish: boolean;
  /**
   * 准入规则 0-门票准入 1-无限制准入
   */
  access_rule: number;
  address_ext: AddressExt;
}
export interface AddressExt {
  province: string;
  city: string;
  latitude: number;
  longitude: number;
  citycode: string;
}
/**
 * 已发布活动信息
 */
export interface PublishedEventInfo {
  start_time: string;
  end_time: string;
  /**
   * 发布事件
   */
  publish_time: string;
}

const DashboardEventBriefInfo = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventBriefInfoRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/brief-info',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventBriefInfo;
